var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"column":""}},[_c('v-flex',[_c('v-card',{attrs:{"xs12":"","lg12":""}},[_c('v-card-text',_vm._l((_vm.icons),function(icon,index){return _c('v-btn',{key:index,staticClass:"mx-3",attrs:{"icon":"","href":icon.link}},[_c('v-icon',{attrs:{"size":"24px","color":icon.color}},[_vm._v(_vm._s(icon.name))])],1)}))],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-495cf414","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Social.vue
// module id = null
// module chunks = 